const dimensionSizes: Record<string, number> = {
    medium: 24,
    large: 32,
}

export const getDimensionValues = (size: "medium" | "large"): number => {
    return dimensionSizes[size];
};

export const formatInstallmentAmountUAH = (value: number, installments: number): string => {
    const dividedValue = Math.ceil(value / installments);

    const formatted = dividedValue
        .toLocaleString('uk-UA', {
            useGrouping: true,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
        .replace(/\u00A0/g, ' ');

    return `${formatted} ₴/міс.`;
}